import React from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";

function ModalFormulas(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});


    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [formulaSeleccionada, setFormulaSeleccionada] = useState(null);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false); // 🆕 Modal post-guardado

    // 🎯 ESTADOS PARA ACORDEONES REACT
    const [acordeonFechaHora, setAcordeonFechaHora] = useState(true);
    const [acordeonContenido, setAcordeonContenido] = useState(false);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-formulas', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        //cargaritems();

    }, []);


    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/formulas', config2)
            .then(response => {
                console.log('Respuesta formulas:', response.data);
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    // 1. Tabla de información (Fecha unificada)
                    let segmentoInfo = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla Profesional (Invertido: ahora antes del contenido)
                    let segmentoProfesional = '';
                    if (item.profesional_tratante_completo && item.profesional_tratante_completo !== 'No registrado') {
                        segmentoProfesional = `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional_tratante_completo}</td>
                                        </tr>`;

                        if (item.profesional && item.firma) {
                            segmentoProfesional += `
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <img src="${item.firma}" style="max-width: 180px; max-height: 80px; display: block;" />
                                                <div style="margin-top: 4px; font-size: 11px; color: #666;">
                                                    ${item.profesional}<br/>
                                                    RM: ${item.registro_medico || ''} | Cód. Hab: ${item.codigo_habilitacion || ''}
                                                </div>
                                            </td>
                                        </tr>`;
                        }
                        segmentoProfesional += `
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 3. Tabla Contenido (Fórmula)
                    let segmentoContenido = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FÓRMULA MÉDICA</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                            ${item.contenido || 'Sin contenido especificado'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    const itemParcial = segmentoInfo + segmentoProfesional + segmentoContenido + "<hr style='border-top: 2px solid #e0e0e0; margin: 25px 0;'>";

                    consolidadoItems += itemParcial;
                    return null; // Add return for map function
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log('Error cargando formulas:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }



    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }




    const handleSubmit = (e) => {

        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            firma: firmaimg,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        console.log('Enviando datos de formula:', data);

        axios.post('/formula', data, config)
            .then(response => {
                console.log('Formula guardada exitosamente:', response.data);
                setLoading(false);
                // ❌ ELIMINADO: props.guardarCambios('La fórmula ha sido agregada');
                setDeshabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({}); // Limpiar errores en caso de éxito

                // 🆕 Mostrar modal de confirmación post-guardado
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando formula:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                }
            })

    }


    const establecerFechaHoraActual = () => {
        const ahora = new Date();
        const fechaFormateada = ahora.toISOString().slice(0, 16);
        setFechaHora(fechaFormateada);
    }

    // 🆕 Función para generar encabezado personalizado HTML
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        // Función auxiliar para limpiar HTML y evitar saltos de línea innecesarios
        const limpiarHTML = (html) => {
            if (!html) return '';
            // Reemplazar <p> tags con divs para un control más preciso
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        // USAR TABLA EN LUGAR DE FLEXBOX PARA MEJOR COMPATIBILIDAD CON PDF
        // FONDO BLANCO Y SIN BORDES
        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <!-- Columna Izquierda (30%) -->
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <!-- Columna Centro (40%) -->
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <!-- Columna Derecha (30%) -->
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const verFormula = (formula) => {
        // Preparar contenido para modal de vista previa usando el MISMO formato que el PDF
        setTituloResumen('Fórmula Médica - Vista Previa');
        setFormulaSeleccionada(formula); // Guardar para PDF

        // Obtener información del paciente desde props
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';

        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 🎨 USAR EL MISMO FORMATO QUE EL PDF - Estilo tabla con bandas grises

        // 1. BANNER (igual que PDF)
        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    FÓRMULA MÉDICA
                </div>
            </div>`;

        // 2. Tabla de información (igual que PDF)
        let tablaInfoPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${formula.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 3. Tabla de contenido (igual que PDF)
        let tablaContenido = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FÓRMULA</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${formula.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Tabla profesional (igual que PDF)
        let tablaProfesional = '';
        if (formula.profesional_tratante_completo && formula.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 16px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${formula.profesional_tratante_completo}</td>
                            </tr>`;

            if (formula.profesional && formula.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                    <img src="${formula.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 6px; font-size: 12px; color: #6c757d;">
                                        ${formula.profesional}<br/>
                                        <strong>RM:</strong> ${formula.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${formula.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }
            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        } else {
            tablaProfesional = `
                <div style="margin-top: 16px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; color: #6c757d; font-style: italic;">No registrado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        // Unir todo el contenido con el mismo formato que el PDF
        const contenidoResumen = banner + tablaInfoPaciente + tablaContenido + tablaProfesional;

        setContenidoResumenIndividual(contenidoResumen);

        // Abrir modal de vista previa
        setShowModalResumen(true);
    }

    const nuevaFormula = () => {
        // Limpiar formulario para nueva fórmula
        setFormulaSeleccionada(null);
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        // Resetear acordeones
        setAcordeonFechaHora(true);
        setAcordeonContenido(false);

        // Limpiar formulario
        if (document.getElementById('plantillas')) {
            document.getElementById('plantillas').value = "";
        }
    }

    const descargarPdfFormula = () => {
        if (!formulaSeleccionada) return;

        var opt = {
            margin: 10,
            filename: 'formula-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // 🆕 Callback para agregar foliación (numeración de páginas)
        const addPageNumbers = (pdf) => {
            const pageCount = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdf.setPage(i);
                pdf.setFontSize(9);
                pdf.setTextColor(100);
                pdf.text('Página ' + i + ' de ' + pageCount, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }
        };

        // 1. Encabezado Personalizado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del paciente
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';
        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 2. BANNER: FÓRMULA MÉDICA (estilo factura)
        let banner = `
            <div style="margin-bottom: 8px;">
                <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                    FÓRMULA MÉDICA
                </div>
            </div>`;

        // 3. Información del Paciente y Fecha unificada (estilo tabla con bandas grises)
        let tablaInfoPaciente = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${formulaSeleccionada.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Contenido de la fórmula (con banda gris)
        let tablaContenido = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FÓRMULA</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${formulaSeleccionada.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 5. Profesional Tratante y Firma (estilo tabla con bandas grises) - CON page-break-inside: avoid
        let tablaProfesional = '';
        if (formulaSeleccionada.profesional_tratante_completo && formulaSeleccionada.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 12px; page-break-inside: avoid;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 30%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${formulaSeleccionada.profesional_tratante_completo}</td>
                            </tr>`;

            // Solo mostrar firma si hay profesional tratante registrado
            if (formulaSeleccionada.profesional && formulaSeleccionada.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6;">
                                    <img src="${formulaSeleccionada.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 4px; font-size: 9px; color: #6c757d;">
                                        ${formulaSeleccionada.profesional}<br/>
                                        <strong>RM:</strong> ${formulaSeleccionada.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${formulaSeleccionada.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }

            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        } else {
            tablaProfesional = `
                <div style="margin-top: 12px; page-break-inside: avoid;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 30%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; color: #6c757d; font-style: italic;">No registrado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        // Unir todo el contenido
        let contenidoImpresion = encabezadoHTML + banner + tablaInfoPaciente + tablaContenido + tablaProfesional;

        // Generar PDF con foliación
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            pdf.save(opt.filename);
        });
    }

    const descargarPdfConsolidado = () => {
        var opt = {
            margin: 10,
            filename: 'formulas-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // 1. Encabezado Personalizado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del paciente
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';
        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 2. BANNER: FÓRMULAS CONSOLIDADAS (estilo factura)
        let banner = `
            <div style="margin-bottom: 8px;">
                <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                    FÓRMULAS CONSOLIDADAS
                </div>
            </div>`;

        // 3. Información del Paciente (estilo tabla con bandas grises)
        let tablaPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Construir contenido de fórmulas consolidadas con tablas
        let formulasHTML = '';
        if (historial && historial.length > 0) {
            historial.forEach((formula, index) => {
                // Tabla para cada fórmula
                let tablaFormula = `
                    <div style="margin-bottom: 12px; page-break-inside: avoid;">
                        <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                            <tbody>
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                    <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${formula.fecha}</td>
                                </tr>`;

                // Profesional Tratante
                if (formula.profesional_tratante_completo && formula.profesional_tratante_completo !== 'No registrado') {
                    tablaFormula += `
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                    <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${formula.profesional_tratante_completo}</td>
                                </tr>`;
                }

                // Contenido de la fórmula
                tablaFormula += `
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FÓRMULA</td>
                                    <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                                        ${formula.contenido || 'Sin contenido especificado'}
                                    </td>
                                </tr>`;

                // Firma (solo si hay profesional tratante registrado)
                if (formula.profesional_tratante_completo && formula.profesional_tratante_completo !== 'No registrado' && formula.profesional && formula.firma) {
                    tablaFormula += `
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                    <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6;">
                                        <img src="${formula.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                        <div style="margin-top: 4px; font-size: 9px; color: #6c757d;">
                                            ${formula.profesional}<br/>
                                            <strong>RM:</strong> ${formula.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${formula.codigo_habilitacion || 'N/A'}
                                        </div>
                                    </td>
                                </tr>`;
                }

                tablaFormula += `
                            </tbody>
                        </table>
                    </div>`;

                formulasHTML += tablaFormula;

                // Separador entre fórmulas (excepto la última)
                if (index < historial.length - 1) {
                    formulasHTML += `<hr style="border-top: 2px solid #e0e0e0; margin: 12px 0;">`;
                }
            });
        }

        let contenidoImpresion = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif; font-size: 10px;">' +
            banner +
            tablaPaciente +
            formulasHTML +
            '</div>';

        // Generar PDF con foliación
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            pdf.save(opt.filename);
        });
    }

    // 🆕 Función para imprimir PDF consolidado
    const imprimirPdfConsolidado = () => {
        var opt = {
            margin: 10,
            filename: 'formulas-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // 1. Encabezado Personalizado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del paciente
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';
        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 2. BANNER: FÓRMULAS CONSOLIDADAS (estilo factura)
        let banner = `
            <div style="margin-bottom: 8px;">
                <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                    FÓRMULAS CONSOLIDADAS
                </div>
            </div>`;

        // 3. Información del Paciente (estilo tabla con bandas grises)
        let tablaPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Construir contenido de fórmulas consolidadas con tablas
        let formulasHTML = '';
        if (historial && historial.length > 0) {
            historial.forEach((formula, index) => {
                // Tabla para cada fórmula
                let tablaFormula = `
                    <div style="margin-bottom: 12px; page-break-inside: avoid;">
                        <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                            <tbody>
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                    <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${formula.fecha}</td>
                                </tr>`;

                // Profesional Tratante
                if (formula.profesional_tratante_completo && formula.profesional_tratante_completo !== 'No registrado') {
                    tablaFormula += `
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                    <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${formula.profesional_tratante_completo}</td>
                                </tr>`;
                }

                // Contenido de la fórmula
                tablaFormula += `
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FÓRMULA</td>
                                    <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                                        ${formula.contenido || 'Sin contenido especificado'}
                                    </td>
                                </tr>`;

                // Firma (solo si hay profesional tratante registrado)
                if (formula.profesional_tratante_completo && formula.profesional_tratante_completo !== 'No registrado' && formula.profesional && formula.firma) {
                    tablaFormula += `
                                <tr>
                                    <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                    <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6;">
                                        <img src="${formula.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                        <div style="margin-top: 4px; font-size: 9px; color: #6c757d;">
                                            ${formula.profesional}<br/>
                                            <strong>RM:</strong> ${formula.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${formula.codigo_habilitacion || 'N/A'}
                                        </div>
                                    </td>
                                </tr>`;
                }

                tablaFormula += `
                            </tbody>
                        </table>
                    </div>`;

                formulasHTML += tablaFormula;

                // Separador entre fórmulas (excepto la última)
                if (index < historial.length - 1) {
                    formulasHTML += `<hr style="border-top: 2px solid #e0e0e0; margin: 12px 0;">`;
                }
            });
        }

        let contenidoImpresion = encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif; font-size: 10px;">' +
            banner +
            tablaPaciente +
            formulasHTML +
            '</div>';

        // Generar PDF con foliación y abrir en nueva pestaña para imprimir
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            window.open(pdf.output('bloburl'), '_blank');
        });
    }

    // 🆕 Función helper para generar contenido del PDF (reutilizable)
    const generarContenidoPDF = (formula) => {
        // 1. Encabezado Personalizado
        let encabezadoHTML = '';
        if (encabezadoPersonalizado) {
            encabezadoHTML = generarEncabezadoHTML();
        }

        // Datos del paciente
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';
        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 2. BANNER: FÓRMULA MÉDICA
        let banner = `
            <div style="margin-bottom: 8px;">
                <div style="background-color: #e9ecef; padding: 4px 8px; font-weight: bold; font-size: 10px; border-radius: 3px; text-align: center; border: 1px solid #dee2e6;">
                    FÓRMULA MÉDICA
                </div>
            </div>`;

        // 3. Información del Paciente y Fecha unificada
        let tablaInfoPaciente = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 20%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${formula.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Contenido de la fórmula
        let tablaContenido = `
            <div style="margin-bottom: 8px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FÓRMULA</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${formula.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 5. Profesional Tratante y Firma
        let tablaProfesional = '';
        if (formula.profesional_tratante_completo && formula.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 12px; page-break-inside: avoid;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; width: 30%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 4px 8px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${formula.profesional_tratante_completo}</td>
                            </tr>`;

            if (formula.profesional && formula.firma) {
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 4px 8px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 8px; border: 1px solid #dee2e6;">
                                    <img src="${formula.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 4px; font-size: 9px; color: #6c757d;">
                                        ${formula.profesional}<br/>
                                        <strong>RM:</strong> ${formula.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${formula.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>`;
            }

            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        }

        return encabezadoHTML +
            '<div style="page-break-before: auto; font-family: sans-serif; font-size: 10px;">' +
            banner +
            tablaInfoPaciente +
            tablaContenido +
            tablaProfesional +
            '</div>';
    };

    // 🆕 Función para imprimir fórmula - Abre el PDF en nueva pestaña para imprimir
    const imprimirFormula = () => {
        if (!formulaSeleccionada) {
            alert('No hay fórmula seleccionada para imprimir');
            return;
        }

        console.log('Imprimiendo fórmula:', formulaSeleccionada);

        var opt = {
            margin: 10,
            filename: 'formula-' + (props.docPaciente || 'paciente') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // Generar contenido usando la función helper
        let contenidoImpresion = generarContenidoPDF(formulaSeleccionada);

        // Generar PDF con foliación y abrir en nueva pestaña para imprimir
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación a cada página
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 5, { align: 'center' });
            }

            // Abrir PDF en nueva pestaña para que el usuario pueda imprimirlo
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);

            // Abrir en nueva pestaña
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                // Esperar a que cargue y abrir diálogo de impresión automáticamente
                printWindow.onload = function () {
                    setTimeout(() => {
                        printWindow.print();
                    }, 500);
                };
            } else {
                // Si el popup fue bloqueado, crear iframe temporal
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            // Limpiar después de un tiempo
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Por favor, descarga el PDF y úsalo para imprimir.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        }).catch(error => {
            console.error('Error generando PDF para impresión:', error);
            alert('Error al generar el PDF para imprimir. Por favor, intenta nuevamente.');
        });
    };

    // 🆕 Funciones del Modal de Confirmación
    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        nuevaFormula();
        props.guardarCambios('La fórmula ha sido guardada exitosamente');
    };

    const handleImprimirDesdeConfirmacion = () => {
        setShowModalConfirmacion(false);
        if (historial && historial.length > 0) {
            const ultimaFormula = historial[0];
            setFormulaSeleccionada(ultimaFormula);
            setTimeout(() => {
                imprimirFormula();
                // 🆕 Limpiar formulario después de que se complete la impresión
                setTimeout(() => nuevaFormula(), 500);
            }, 300);
        }
        props.guardarCambios('La fórmula ha sido guardada exitosamente');
    };

    const handleDescargarPdfDesdeConfirmacion = () => {
        setShowModalConfirmacion(false);
        if (historial && historial.length > 0) {
            const ultimaFormula = historial[0];
            setFormulaSeleccionada(ultimaFormula);
            setTimeout(() => {
                descargarPdfFormula();
                // 🆕 Limpiar formulario después de que se complete la descarga
                setTimeout(() => nuevaFormula(), 500);
            }, 300);
        }
        props.guardarCambios('La fórmula ha sido guardada exitosamente');
    };

    // 🆕 Función para cerrar el modal de vista previa y limpiar recursos
    const cerrarModalResumen = () => {
        // Limpiar blob URL si existe
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.src && iframe.src.startsWith('blob:')) {
            URL.revokeObjectURL(iframe.src);
        }
        setShowModalResumen(false);
    };

    // 🆕 Función para generar vista previa PDF en el modal
    const verResumen = (ttlResumen, resumenIndividual) => {
        setTituloResumen(ttlResumen);
        setFormulaSeleccionada(resumenIndividual);

        // Generar el PDF y mostrarlo en el modal
        var opt = {
            margin: 10,
            filename: 'formula-preview.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        // Generar contenido usando la función helper
        let contenidoImpresion = generarContenidoPDF(resumenIndividual);

        // Generar PDF y mostrarlo en iframe
        html2pdf().from(contenidoImpresion).set(opt).toPdf().get('pdf').then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // Agregar foliación
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(150);
                pdf.text('Página ' + i + ' de ' + totalPages,
                    pdf.internal.pageSize.getWidth() / 2,
                    pdf.internal.pageSize.getHeight() - 5,
                    { align: 'center' });
            }

            // Crear blob URL para iframe
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);

            // Crear iframe HTML
            const iframeHTML = `<iframe src="${url}" style="width: 100%; height: 600px; border: none;"></iframe>`;
            setContenidoResumenIndividual(iframeHTML);

            // Abrir modal
            setShowModalResumen(true);
        });
    }


    useEffect(() => {
        cargaritems();

        // Cleanup para evitar memory leaks
        return () => {
            setHistorial([]);
            setConsolidado('');
            setShowModalResumen(false);
            setShowModalConsolidado(false);
            setFormulaSeleccionada(null);
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `formulas.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 4, useCORS: true, allowTaint: true, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let formulasCompleta = "<img src='" + logoImg + "' className='app-logo-pdf' /><h1 className='ttl-pdf'>FÓRMULAS MÉDICAS</h1>" + anamnesis + "<div className='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(formulasCompleta, opt);
    }


    if (loggedIn) {
        return (


            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* 🆕 PROFESIONAL TRATANTE - Siempre visible */}
                                            <div className="col-md-12">
                                                <div className="card" style={{ marginBottom: '15px' }}>
                                                    <div className="card-body" style={{ padding: '15px' }}>
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza la fórmula</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonFechaHora(!acordeonFechaHora)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100">
                                                            <span className="d-block w-100">
                                                                Fecha y Hora {acordeonFechaHora ? '' : '▼'}
                                                            </span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonFechaHora ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <div className="form-group">
                                                            <label>Fecha y Hora</label>
                                                            <div className="input-group">
                                                                <input type="datetime-local" className="form-control" value={fechaHora} onChange={(e) => setFechaHora(e.target.value)} />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-primary btn-sm" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonContenido(!acordeonContenido)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100">
                                                            <span className="d-block w-100">
                                                                Contenido de la Fórmula {acordeonContenido ? '' : '▼'}
                                                            </span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonContenido ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <label style={{ fontSize: '1rem', marginBottom: '8px' }}>Seleccione la fórmula o digite su contenido</label>
                                                        <div className="form-group">
                                                            <select name="plantillas" className="form-control" id="plantillas" onChange={(e) => setContenido(e.target.value)} >
                                                                <option></option>
                                                                {
                                                                    plantillas.map((plantilla) =>
                                                                        <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        </div>
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.contenido}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label htmlFor="nombreProfesional">Firma</label>
                                                            <br></br>
                                                            <img src={firmaimg} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button className="btn btn-primary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <a href="#" className="btn btn-primary" onClick={(e) => { e.preventDefault(); props.cerrarModal() }}>Cerrar</a>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de fórmulas</b>

                                    {
                                        historial.map((item) =>

                                            <div className="timeline-item-container" key={item.id} onClick={() => verFormula(item)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>

                            </div>

                        </div>

                    </div>
                </section>

                <Modal show={showModalResumen} onHide={cerrarModalResumen} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: contenidoResumenIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={descargarPdfFormula}>
                            <i className="fas fa-file-pdf"></i> Guardar PDF
                        </Button>
                        <Button variant="primary" onClick={imprimirFormula}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="secondary" onClick={cerrarModalResumen}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Resumen Fórmulas Médicas</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={imprimirPdfConsolidado}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="danger" onClick={descargarPdfConsolidado}>
                            <i className="fas fa-file-pdf"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" onClick={() => setShowModalConsolidado(false)}>
                            <i className="fas fa-times"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* 🆕 Modal de Confirmación Post-Guardado */}
                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <i className="fas fa-file-medical"></i> Fórmula Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                            La fórmula ha sido guardada exitosamente. ¿Qué deseas hacer?
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleImprimirDesdeConfirmacion}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="danger" onClick={handleDescargarPdfDesdeConfirmacion}>
                            <i className="fas fa-file-pdf"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalFormulas;